/* ==========================================================================
   SNC Wishlist — NaturaFusión
   Favoritos con localStorage (sin login). Conecta el corazón de cada card
   (data-snc-fav) y el contador del header. Persiste {id, handle} para poder
   rehidratar los productos en /pages/favoritos.
   API pública: window.SNCWishlist
   Evento: 'snc:wishlist:updated' { detail: { count, items } }
   ========================================================================== */
(function () {
  if (window.SNCWishlist) return;

  var KEY = 'snc:wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
  }

  var SNCWishlist = {
    items: read(),

    has: function (id) {
      id = String(id);
      return this.items.some(function (it) { return String(it.id) === id; });
    },

    toggle: function (id, handle) {
      id = String(id);
      if (this.has(id)) {
        this.items = this.items.filter(function (it) { return String(it.id) !== id; });
      } else {
        this.items.push({ id: id, handle: handle || '' });
      }
      write(this.items);
      this.emit();
      return this.has(id);
    },

    count: function () { return this.items.length; },

    emit: function () {
      document.dispatchEvent(new CustomEvent('snc:wishlist:updated', {
        detail: { count: this.items.length, items: this.items.slice() }
      }));
    }
  };

  window.SNCWishlist = SNCWishlist;

  /* ── UI: botones de las cards ── */
  function syncButton(btn) {
    var id = btn.getAttribute('data-product-id');
    var on = SNCWishlist.has(id);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Quitar de favoritos' : 'Agregar a favoritos');
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-snc-fav]').forEach(syncButton);
  }
  SNCWishlist.refreshButtons = syncAllButtons;

  /* ── UI: badge del header ── */
  function syncBadge() {
    var badge = document.querySelector('.snc-wishlist-badge');
    if (!badge) return;
    var n = SNCWishlist.count();
    badge.textContent = n;
    badge.classList.toggle('snc-wishlist-badge--empty', n === 0);
    badge.classList.remove('snc-wishlist-badge--pop');
    // reflow para reiniciar la animación
    void badge.offsetWidth;
    badge.classList.add('snc-wishlist-badge--pop');
  }

  /* ── Delegación de clicks ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-snc-fav]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-product-id');
    var handle = btn.getAttribute('data-product-handle');
    var nowOn = SNCWishlist.toggle(id, handle);

    // sincroniza todas las instancias del mismo producto
    document.querySelectorAll('[data-snc-fav][data-product-id="' + id + '"]').forEach(syncButton);

    if (window.sncToast) {
      window.sncToast(nowOn ? '♥ Agregado a favoritos' : 'Eliminado de favoritos');
    }
  });

  document.addEventListener('snc:wishlist:updated', syncBadge);

  function init() {
    syncAllButtons();
    syncBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
